import { apiClient } from './api-client';

export const transcriptionApi = {
  getPendingAudios: async (params: {
    lang: string;
    page?: number;
    limit?: number;
    excludeIds?: Array<string | number>;
    rotationId?: string | null;
    source?: string;
  }) => {
    const queryParams = new URLSearchParams({
      lang: params.lang,
      page: String(params.page ?? 1),
      limit: String(params.limit ?? 10),
    });
    params.excludeIds?.forEach((id) => queryParams.append('excludeIds', String(id)));
    if (params.rotationId) queryParams.set('rotationId', params.rotationId);
    if (params.source) queryParams.set('source', params.source);

    const { data } = await apiClient.get(`/audio/transcription?${queryParams.toString()}`);
    return data;
  },

  getAudiosWithRandomTranscription: async (params: {
    lang: string;
    page?: number;
    limit?: number;
    source?: string;
  }) => {
    const queryParams = new URLSearchParams({
      lang: params.lang,
      page: String(params.page ?? 1),
      limit: String(params.limit ?? 10),
    });
    if (params.source) queryParams.set('source', params.source);
    const query = queryParams.toString();

    const { data } = await apiClient.get(`/audio/transcription/random?${query}`);
    return data;
  },

  add: async (payload: { audioId: string | number; text: string; textFrancais?: string }) => {
    const url = `/transcriptions/${encodeURIComponent(String(payload.audioId))}/add`;
    const body = {
      text: payload.text,
      textFrancais: payload.textFrancais,
    };
    const { data } = await apiClient.post(url, body);
    return data;
  },

  release: async (payload: { audioId: string | number; rotationId?: string | null }) => {
    const url = `/transcriptions/${encodeURIComponent(String(payload.audioId))}/release`;
    const { data } = await apiClient.post(url, { rotationId: payload.rotationId ?? undefined });
    return data;
  },

  validate: async (payload: {
    audioId: string | number;
    transcriptionText: string;
    action?: 'accept' | 'reject';
    reason?: string;
  }) => {
    const url = `/transcriptions/${encodeURIComponent(String(payload.audioId))}/validate`;
    const body: Record<string, unknown> = {
      text: payload.transcriptionText,
    };
    if (payload.action) body.action = payload.action;
    if (payload.reason) body.reason = payload.reason;
    const { data } = await apiClient.post(url, body);
    return data;
  },

  finalize: async (payload: { audioId: string | number; text: string }) => {
    const url = `/transcriptions/${encodeURIComponent(String(payload.audioId))}/finalize`;
    const body = { text: payload.text };
    const { data } = await apiClient.post(url, body);
    return data;
  },
};
